module.exports = __webpack_public_path__ + "static/media/icon-file-selected.a092a9ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/FileItem/assets/icon-file-selected.svg
// module id = 2472
// module chunks = 193